import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import UploadedDoc from '../../components/UploadedDoc';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import UploadDocs from '../Onboarding/UploadDocs';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Alert } from 'antd';

const styles = theme => ({
    root: {
        //width: '100%',
        // height: '100vh', /* Magic here */
        marginLeft:'20px',
        marginBottom:'20px'

        //margin: '0 auto',
    },
    uploadDocs:{
        marginTop:'20px'
        //margin: '0 auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    margin : {
        marginTop:'40px',
        fontWeight: 'bold'
    },
    bInput: {
      background: "rgba(255, 255, 255, 0.5)",
      outline: "0",
      color: "#99192D",
      wordWrap: "break-word",
      wordBreak: "break-word",
      textTransform: 'none',
      border: "2px solid #99192D",
      paddingTop: "15px",
      paddingBottom: "15px",
      borderRadius: "25px",
      // height: "30px",
      marginLeft: "3px",
      marginRight: "3px",
      boxSizing: "border-box",
      fontSize: "16px",
      "&:hover": {
        color: "white",
      },
    },
});

class timerPanel extends Component {
    state = {
      AddNoOfDays:0,
      typeOfAccount:localStorage.getItem('typeOfAccount')
    };

    componentWillMount(){
        
    }

    componentDidMount(){
        // this.props.getCaseInfo(this.props.caseId, localStorage.getItem('token'));
        // console.log('doclsit currentUser: '+this.state.currentUser);
        // console.log('doclsot userType: '+this.props.userType);
        
    }

    handleChange = prop => event => {
        this.setState({[prop]: event.target.value});
        //this.props.setArbitrator(event.target.value);
    }

    handleChangeNoOfDays = () => {
        this.props.changeNoOfDays(this.props.caseData.caseId, this.state.AddNoOfDays, localStorage.getItem('token'))
    }

    handleReAskSignature = (userType) => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/reAskSignature`;
    
        const reAskClaimantSignature = {
            caseId: this.props.caseData.caseId,
            userType: userType
        };

        axios.post(url, {
            ...reAskClaimantSignature
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                
            }
            else{
                alert("Request Sent to Claimant")
            }
        })
    }

    skipPaymentForClaimant = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/savePaymentDetails`;
    
        const skipPaymentForClaimants = {
            "payment_details":{
                "timestamp":"",
                "paid": "manually paid"
            },
            "userType":"claimant",
            "caseId":(''+this.props.caseData.caseId)
        }

        axios.post(url, {
            ...skipPaymentForClaimants
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                alert("Failed to skip payment for claimant.")
            }
            else{
                alert("Payment skipped for claimant.")
            }
        })
    }

    arbitratorNoEnquiry = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/arbitratorNoEnquiry`;
    
        const arbitratorNoEnquiryData = {
            "caseId":(''+this.props.caseData.caseId)
        }

        axios.post(url, {
            ...arbitratorNoEnquiryData
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                alert("Failed to process arbitrator no enquiry.")
            }
            else{
                alert("Arbitrator no enquiry processed.")
            }
        })
    }

    handleReAskRespondentSignature = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/reAskRespondentSignature`;
    
        const reAskClaimantSignature = {
            caseId: this.props.caseData.caseId,
        };

        axios.post(url, {
            ...reAskClaimantSignature
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                
            }
            else{
                alert("Request Sent to Respondent")
            }
        })
    }

    submitHandler = (event) => {
        event.preventDefault(); 
    };

    render(){
        const { classes } = this.props;
        var disableUploadDoc = false

        return(
            <div className={classes.root}>

            <Typography variant="h5" className={classes.margin} gutterBottom>
                {this.context.t("Timer Panel")}:
            </Typography>
            <TextField
                id="timepanel"
                label={this.context.t('Add No. of Days')}
                value={this.state.AddNoOfDays}
                onChange={this.handleChange('AddNoOfDays')}
                InputProps={{style: {fontSize: '14px'}  }}
                margin="normal"
                InputLabelProps={{
                  style: {fontSize: '14px'},
                }}
            />
            <Button
                variant="contained"
                className={classes.bInput}
                type="submit"
                color="primary"
                style={{textAlign: 'center'}}
                onClick={() => { this.handleChangeNoOfDays() }}
            >
                {this.context.t('Change No. Of Days')}
            </Button> 
                <br></br><br></br>
            <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.bInput}
                style={{textAlign: 'center'}}
                onClick={() => { this.handleReAskSignature('claimant') }}
            >
                {this.context.t('Request Claimant Signature')}
            </Button> 
                <br></br><br></br>
            <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.bInput}
                style={{textAlign: 'center'}}
                onClick={() => { this.handleReAskSignature('respondent') }}
            >
                {this.context.t('Request Respondent Signature')}
            </Button> 
                <br></br><br></br>
            <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.bInput}
                style={{textAlign: 'center'}}
                // onClick={this.handleChangeNoOfDays} 
                onClick={() => { this.skipPaymentForClaimant() }}
            >
                {this.context.t('Skip Payment')}
            </Button> 

                <br></br><br></br>
            <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.bInput}
                style={{textAlign: 'center'}}
                // onClick={this.handleChangeNoOfDays} 
                onClick={() => { this.arbitratorNoEnquiry() }}
            >
                {this.context.t('Enquiry by arbitrator is completed')}
            </Button> 
            
            <div></div>
        </div>
    
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        files: state.uploadDocs.files,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
        removeFile: (filename) => dispatch(actions.removeFile(filename)),
        uploadDocs : (files) => dispatch(actions.uploadDocs(files)),
        changeNoOfDays: (caseId, NoOfDays, uniqueId) => dispatch(actions.changeNoOfDays(caseId, NoOfDays, uniqueId))
    }
}

timerPanel.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(timerPanel));
